import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import Loading from '../components/Loading';
import { Integration, IntegrationType, IntegrationStatus } from '../types';
import './Pages.css';

const Integrations: React.FC = () => {
  const [integrations, setIntegrations] = useState<Integration[]>([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadIntegrations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadIntegrations = async () => {
    try {
      const response = await api.get<Integration[]>('/admin/integrations');
      setIntegrations(response.data);
    } catch (error) {
      console.error('Error loading integrations:', error);
    } finally {
      setLoading(false);
    }
  };

  const getIntegrationTypeName = (type: IntegrationType): string => {
    switch (type) {
      case IntegrationType.KdoqDelivery:
        return 'Kdoq Delivery';
      case IntegrationType.Ifood:
        return 'iFood';
      default:
        return 'Desconhecido';
    }
  };

  const getIntegrationStatusName = (status: IntegrationStatus): string => {
    switch (status) {
      case IntegrationStatus.Active:
        return 'Ativo';
      case IntegrationStatus.Inactive:
        return 'Inativo';
      case IntegrationStatus.Pending:
        return 'Pendente';
      default:
        return 'Desconhecido';
    }
  };

  const getIntegrationStatusClassName = (status: IntegrationStatus): string => {
    switch (status) {
      case IntegrationStatus.Active:
        return 'active';
      case IntegrationStatus.Inactive:
        return 'inactive';
      case IntegrationStatus.Pending:
        return 'pending';
      default:
        return 'inactive';
    }
  };

  if (loading) return <Loading message="Carregando integrações..." />;

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Integrações</h1>
          <p>Gerencie suas integrações com plataformas de delivery</p>
        </div>
        <button className="btn-primary" onClick={() => setShowModal(true)}>
          + Adicionar Integração
        </button>
      </div>

      {integrations.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '60px 20px',
          color: 'var(--text-gray)'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔌</div>
          <h3 style={{ marginBottom: '10px', color: 'var(--text-dark)' }}>Nenhuma integração configurada</h3>
          <p>Adicione integrações para conectar sua loja com plataformas de delivery.</p>
        </div>
      ) : (
        <div className="plans-grid">
          {integrations.map((integration) => (
            <div key={integration.integrationId} className="plan-card">
              <div className="plan-header">
                <h3>{getIntegrationTypeName(integration.type)}</h3>
                <span className={`status-badge ${getIntegrationStatusClassName(integration.status)}`}>
                  {getIntegrationStatusName(integration.status)}
                </span>
              </div>
              <div className="plan-info">
                <div className="info-item">
                  <span className="info-label">Tipo:</span>
                  <span>{getIntegrationTypeName(integration.type)}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Status:</span>
                  <span>{getIntegrationStatusName(integration.status)}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Criado em:</span>
                  <span>{new Date(integration.createdAt).toLocaleDateString('pt-BR')}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '28px' }}>
              <h2>Adicionar Integração</h2>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#666',
                  padding: '0',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ×
              </button>
            </div>
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              color: 'var(--text-dark)'
            }}>
              <div style={{ fontSize: '64px', marginBottom: '24px' }}>📞</div>
              <h3 style={{ marginBottom: '16px', fontSize: '24px', fontWeight: 700 }}>
                Entre em contato conosco
              </h3>
              <p style={{
                fontSize: '16px',
                lineHeight: '1.6',
                color: 'var(--text-gray)',
                marginBottom: '32px'
              }}>
                As integrações devem ser feitas através da equipe FidHub.
                <br />
                Entre em contato conosco para configurar suas integrações.
              </p>
              <div className="modal-actions" style={{ justifyContent: 'center' }}>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => setShowModal(false)}
                >
                  Entendi
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Integrations;

